import React from 'react';

export const PracticeBlockMain = (props) => {
  return <h1>{console.log(props.contentData)}</h1>;
};
